import { useSelector } from "react-redux";
import {
    Navigate,
    useLocation
} from "react-router-dom";

export const Paywall = ({ login, subscriptionPlan, children }) => {
    const { user: account } = useSelector((state) => state.auth);
    const loginMatch = login && account.login === login;
    const subscriptionPlanMatch = subscriptionPlan && subscriptionPlan <= parseInt(account.subscription_plan_code)
    const matched = Boolean(loginMatch || subscriptionPlanMatch);
    let location = useLocation();

    if (!matched) {
        return <Navigate to="/unactive" state={{ from: location }} />;
    }

    return children;
};
